import { useRef, useState } from 'preact/hooks'
import clsx from 'clsx'
import useClickOutSide from 'hooks/useClickOutSide'
import PlpNativeSortOptions from 'snippets/plp-native/plp-native-sort/plp-native-sort-options'
import Icon from 'snippets/icon/icon'

function PlpNativeSort() {
  const refSortEl = useRef(null)
  const [isActive, setIsActive] = useState(false)

  const handleClickOutSide = () => setIsActive(false)

  useClickOutSide(refSortEl, handleClickOutSide)

  return (
    <div ref={refSortEl} className="flex items-center justify-center border-l border-neutral-900 py-3 px-5 md:px-10">
      <button type="button" className="flex items-center" onClick={() => setIsActive(!isActive)}>
        <p className="text-xs text-neutral-900">{translate.collection.sort}</p>
        <Icon
          viewBox="0 0 16 16"
          name="icon-chevron-down"
          className={clsx('ml-1.5 size-3 text-neutral-900 transition-all duration-300', {
            'rotate-180': isActive,
            'rotate-0': !isActive
          })}
        />
      </button>
      <PlpNativeSortOptions isActive={isActive} setIsActive={setIsActive} />
    </div>
  )
}

export default PlpNativeSort
